module.exports = __webpack_public_path__ + "static/media/arrow-white.8ce4220c.svg";